import slice from './reducer'
import * as selectors from './selectors'

export { selectors }
export const {
  openSmsCompose,
  closeSms,
  setSmsCollapsed,
  smsSendStarted,
  smsSent,
  smsSendFailed,
  smsDraftCreated,
  smsDraftUpdateStarted,
  smsDraftUpdated,
  smsReceiptRequested,
  smsReceiptLoaded,
  smsReceiptFailed,
  smsSendingSucceeded,
  smsSendingFailed,
  smsSendingStatusRefetched,
  setSmsCreateContact,
  smsContactCreateStarted,
  smsContactCreated,
  smsContactCreateFailed,
  smsRecipientAdded,
  smsRecipientsAdded,
  smsRecipientRemoved,
  smsRecipientsLoadingStarted,
  smsRecipientsLoadingFinished,
  resetSms,
} = slice.actions
export const SendSmsReducer = slice.reducer
